import {
  Box,
  VStack,
  Input,
  FormControl,
  FormLabel,
  Button,
  Heading,
  Spinner,
  InputGroup,
  InputLeftElement,
  Flex,
  Text,
  useToast,
  Stack,
  Tag,
  TagLabel,
  TagRightIcon,
} from "@chakra-ui/react";
import { useEffect, useState, useContext, Fragment, useRef } from "react";
import { useNavigate, useOutletContext } from "react-router-dom";
import { Select } from "chakra-react-select";
import { TARM_AWS_URL } from "../../api/api";
import axios from "axios";
import { AccountContext } from "../../context/AccountContext";
import { getRunID } from "../../util/runID";
import { CheckIcon, DeleteIcon, InfoIcon } from "@chakra-ui/icons";
import uploadFile from "./../../assets/upload-file.svg";
import cid from './../../assets/cid.xlsx'
import Loading from "../Loading/Loading";
import { removeKeys, serializeDataForSelect } from "../../util/utility";

const CreateResumePool = () => {
  const navigate = useNavigate();
  const [source] = useState(axios.CancelToken.source());
  const [setHasStripe, setProgressValue] = useOutletContext();
  const [run_id] = useState(getRunID())
  const [poolName, setPoolName] = useState("");
  const [boxFolderId, setBoxFolderId] = useState("157994133702");
  const [boxFileName, setBoxFileName] = useState("");
  const [isLoading, setIsLoading] = useState(true);
  const [isBtnLoading, setIsBtnLoading] = useState(false);
  const [selectedJobProfiles, setSelectedJobProfiles] = useState([]);
  const [allJobProfiles, setAllJobProfiles] = useState([]);
  const [careerStage, setCareerStage] = useState(null);
  const [sesIds, setSesIds] = useState([]);

  const [CIDFileUpload, setCIDFileUpload] = useState("");
  const [uploadResumes, setUploadResumes] = useState("");
  const [isUploadResumesBtnLoading, setIsUploadResumesBtnLoading] = useState(false);
  const [isResumesUploaded, setIsResumesUploaded] = useState(false);
  const inputRefCID = useRef();
  const inputRefUploadResumes = useRef();
  const { user } = useContext(AccountContext);
  const [destinationEmail, setDestinationEmail] = useState([{ label: user.email, value: user.email }]);
  const toast = useToast()
  const careerStages = [
    "manager",
    "lead",
    "senior associate",
    "senior",
    "associate",
    "junior",
  ];


  const handleJobProfileChange = (selectedItems) => {
    if (selectedItems.length <= 10) {
      setSelectedJobProfiles(selectedItems);
    } else {
      toast({
        title: "Max limit reached",
        status: "warning",
        duration: 3000,
        isClosable: true,
      });
    }
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    setIsBtnLoading(true);
    const author_email = user.email
    const jds = removeKeys(selectedJobProfiles, ['label', 'value']);
    const destination_email = destinationEmail
      .map((obj) => obj.value)
      .join(',');

    const postBody = {
      pool_name: poolName,
      folder_id: boxFolderId,
      box_file_name: boxFileName.trim(),
      author_email: author_email,
      destination_email: destination_email,
      job_title: careerStage.value,
      jds: jds,
      run_id: run_id,
      box_upload: !isResumesUploaded
    };

    try {
      const response = await TARM_AWS_URL.post(
        "configure-step-function",
        JSON.stringify(postBody),
        {
          cancelToken: source.token,
        }
      );
      console.log(response)
      if (response.status === 200 && CIDFileUpload) {
        const response = await TARM_AWS_URL.get("jd-parser/upload-cid", {
          params: {
            run_id: run_id,
            author_email: author_email
          }
        },
          {
            cancelToken: source.token,
          });
        console.log(response)
        const responseData = response.data
        const fields = responseData.fields
        const url = responseData.url
        if (response.status === 200) {
          const formData = new FormData();
          formData.append('AWSAccessKeyId', fields.AWSAccessKeyId)
          formData.append('key', fields['key'])
          formData.append('policy', fields['policy'])
          formData.append('signature', fields['signature'])
          formData.append('x-amz-security-token', fields['x-amz-security-token'])
          formData.append("file", CIDFileUpload)
          const response = await axios.post(url, formData, { cancelToken: source.token })
          console.log(response)
        }
      }
      navigate("/home/success", {
        state: { redirectURL: `/home/batch-ops/progress/${author_email}/${run_id}`, replace: true },
      });
    } catch (error) {
      handleError(error);
    } finally {
      setIsBtnLoading(false);
    }
  };


  useEffect(() => {
    fetchJdsAndSesIds()
    return () => {
      if (source) {
        source.cancel();
      }
    };
  }, []);

  const fetchJdsAndSesIds = async () => {
    try {
      const [jobProfilesResponse, sesIdsResponse] = await Promise.all([
        TARM_AWS_URL.get('jd-parser/get-db-items?identifier=jds', {
          cancelToken: source.token,
        }),
        TARM_AWS_URL.get('get-ses-ids', { cancelToken: source.token }),
      ]);
      setAllJobProfiles(serializeDataForSelect(jobProfilesResponse.data, 'PK'));
      setSesIds(sesIdsResponse.data);
    } catch (error) {
      handleError(error);
    } finally {
      setIsLoading(false); // Stop loading after fetching
    }
  };

  const handleError = (error) => {
    console.error(error); // Log error to console for debugging
    toast({
      title: error.message,
      status: "error",
      duration: 3000,
      isClosable: true,
    });
  };

  const uploadResumesHandler = async () => {
    if (!uploadResumes) return
    console.log(poolName)
    console.log(uploadResumes.name)
    setIsUploadResumesBtnLoading(true);
    try {
      const author_email = user.email
      const response = await TARM_AWS_URL.get("upload-resumes", {
        params: {
          author_email: author_email,
          run_id: run_id,
          zip_filename: uploadResumes.name
        }
      }, {
        cancelToken: source.token,
      })
      console.log(response)
      const responseData = response.data
      const fields = responseData.fields
      const url = responseData.url
      const options = {
        onUploadProgress: (progressEvent) => {
          const percentCompleted = Math.round(
            (progressEvent.loaded * 100) / progressEvent.total
          );
          setProgressValue(percentCompleted);
        },
      };

      if (response.status === 200) {
        const formData = new FormData();
        for (const key in fields) {
          if (fields.hasOwnProperty(key)) {
            formData.append(key, fields[key]);
          }
        }
        formData.append("file", uploadResumes)
        const response = await axios.post(url, formData, options, { cancelToken: source.token })
        console.log(response)
        setIsResumesUploaded(true)
        toast({
          title: `${uploadResumes.name} uploaded successfully!`,
          status: "success",
          duration: 3000,
          isClosable: true,
        });
      }
    } catch (error) {
      handleError(error);
      setIsResumesUploaded(false)
    } finally {
      setIsUploadResumesBtnLoading(false);
      setHasStripe(false)
      setProgressValue(0)
    }
  }

  const handlePoolNameChange = (event) => {
    // Remove all dots and replace spaces with underscores
    const sanitizedValue = event.target.value.replace(/[.]/g, '').replace(/\s/g, '_');
    setPoolName(sanitizedValue)
  }


  return isLoading ? (
    <Loading loading={isLoading} />) :
    <VStack>
      <Heading>Create a new resume pool</Heading>
      <br />
      <Box borderWidth="3px" borderRadius="lg" p="10" width="700px" height="75vh" overflowY="scroll">
        <form onSubmit={handleSubmit}>
          <FormControl isRequired>
            <FormLabel htmlFor="poolName">
              Enter pool name
            </FormLabel>
            <Input
              id="poolName"
              type="text"
              name="poolName"
              value={poolName}
              onChange={handlePoolNameChange}
            />
          </FormControl>

          {
            !boxFileName && <>
              <FormControl isRequired mt={4}>
                <FormLabel htmlFor="uploadResume">
                  Upload resumes in zip file
                </FormLabel>
                <InputGroup>
                  <InputLeftElement pointerEvents="none">
                    <img
                      style={{ height: "22px" }}
                      src={uploadFile}
                      alt="Upload File"
                    />
                  </InputLeftElement>
                  <input
                    type="file"
                    onChange={(e) => setUploadResumes(e.target.files[0])}
                    accept=".zip"
                    name={uploadResumes.name}
                    ref={inputRefUploadResumes}
                    style={{ display: "none" }}
                  />
                  <Input
                    id="uploadResumes"
                    placeholder="Click here to upload zip"
                    onClick={() => inputRefUploadResumes.current.click()}
                    className="cursor-pointer "
                    readOnly={true}
                    value={(uploadResumes && uploadResumes.name) || ""}
                  />
                </InputGroup>
              </FormControl>
              {uploadResumes && isResumesUploaded ? (
                <Stack direction='row' justify="end" mt="1"><Tag size="md" variant='subtle' colorScheme='green'>
                  <TagRightIcon as={CheckIcon} />
                  <TagLabel ml="2">Uploaded</TagLabel>
                </Tag></Stack>) : (
                <Stack direction='row' spacing={2} justify="end" mt="1">
                  <Button size="xs"
                    colorScheme='blue'
                    variant='solid'
                    onClick={uploadResumesHandler}
                    disabled={isUploadResumesBtnLoading || !uploadResumes}>
                    {isUploadResumesBtnLoading && <Spinner size="xs" mr={2} />}
                    Upload
                  </Button>
                  <Button size="xs"
                    colorScheme='red'
                    variant='solid'
                    onClick={(e) => { setUploadResumes(""); inputRefUploadResumes.current.value = "" }}
                    disabled={isUploadResumesBtnLoading || !uploadResumes}>
                    Cancel
                  </Button>

                </Stack>
              )}
            </>
          }



          {/* {
            !uploadResumes && <><FormControl isRequired mt={4}>
              <FormLabel htmlFor="boxFolderId">
                Box folder ID
              </FormLabel>
              <Input
                id="boxFolderId"
                type="text"
                disabled={true}
                variant="filled"
                name="boxFolderId"
                value={boxFolderId}
                onChange={(e) => setBoxFolderId(e.target.value)}
              />
            </FormControl>

              <FormControl isRequired mt={4}>
                <FormLabel htmlFor="zipFileName">
                  Zip file name (file available on box)
                </FormLabel>
                <Input
                  id="zipFileName"
                  type="text"
                  value={boxFileName}
                  name="zipFileName"
                  onChange={(e) => setBoxFileName(e.target.value)}
                />
              </FormControl></>
          } */}


          <FormControl isRequired mt={4}>
            <FormLabel>Select job profiles (max 15)</FormLabel>
            <Select
              isMulti={true}
              options={allJobProfiles}
              placeholder="Search job profiles"
              closeMenuOnSelect={false}
              name="selectedJobProfiles"
              value={selectedJobProfiles}
              onChange={handleJobProfileChange}
            />
          </FormControl>

          <FormControl isRequired mt={4}>
            <FormLabel htmlFor="careerStages">
              Select career stage
            </FormLabel>
            <Select
              id="careerStages"
              name="careerStage"
              options={careerStages.map((stage) => ({
                label: stage,
                value: stage,
              }))}
              value={careerStage}
              onChange={(e) => setCareerStage(e)}
              placeholder="Search career stages"
              closeMenuOnSelect={true}
            />
          </FormControl>

          <FormControl isRequired mt={4}>
            <FormLabel htmlFor="sesIds">
              Select email ids to send reports to
            </FormLabel>
            <Select
              isMulti={true}
              id="sesIds"
              name="sesIds"
              options={sesIds.map((stage) => ({
                label: stage,
                value: stage,
              }))}
              value={destinationEmail}
              onChange={(e) => setDestinationEmail(e)}
              placeholder="Select email to send reports"
              closeMenuOnSelect={false}
            />
          </FormControl>

          {/* <Fragment>
            <FormControl mt={4}>
              <FormLabel htmlFor="CIDFileUpload">
                Please provide CID file (accepts .xlsx)
              </FormLabel>
              <InputGroup>
                <InputLeftElement pointerEvents="none">
                  <img
                    style={{ height: "22px" }}
                    src={uploadFile}
                    alt="Upload File"
                  />
                </InputLeftElement>
                <input
                  type="file"
                  onChange={(e) => setCIDFileUpload(e.target.files[0])}
                  accept=".xlsx"
                  name={CIDFileUpload.name}
                  ref={inputRefCID}
                  style={{ display: "none" }}
                />
                <Input
                  id="CIDFileUpload"
                  placeholder="Upload CID file"
                  onClick={() => inputRefCID.current.click()}
                  className="cursor-pointer"
                  readOnly={true}
                  value={(CIDFileUpload && CIDFileUpload.name) || ""}
                />
              </InputGroup>
            </FormControl>

            {CIDFileUpload && (
              <Box p="2">
                <Flex justify="space-between">
                  <Text>{CIDFileUpload.name}</Text>
                  <DeleteIcon
                    mt={1}
                    color="gray"
                    className="cursor-pointer close-icon"
                    onClick={(e) => {
                      setCIDFileUpload("");
                      inputRefCID.current.value = "";
                    }}
                  />
                </Flex>
              </Box>
            )}
            <Box mt="1">
              <Text fontSize="xs">
                <InfoIcon mb="1" mr="1" />
                Column names must be in format specified
              </Text>
              <a href={cid} download="cid.xlsx"><Text fontSize="xs" color="blue.500" ml="4">Click here to download sample cid.xlsx file</Text></a>
            </Box>

          </Fragment> */}

          <Box textAlign="end" mt="4">
            <Button
              type="submit"
              colorScheme="blue"
              disabled={
                !(
                  poolName &&
                  (boxFileName || isResumesUploaded) &&
                  selectedJobProfiles.length > 0 &&
                  destinationEmail.length > 0 &&
                  careerStage
                ) || isBtnLoading
              }
            >
              {isBtnLoading && <Spinner size="sm" mr={2} />}
              Submit
            </Button>
          </Box>
        </form>
      </Box>
    </VStack>
};

export default CreateResumePool;
